<template>
    <div>
        <v-autocomplete
            v-model="selectedRegistration"
            :items="registrations"
            label="Jalur"
            hide-details
        ></v-autocomplete>
        Total: {{ filteredEnrollments.length }}
    </div>
</template>

<script>
export default {
    props: {
        enrollments: {
            type: Array,
        },
        filteredEnrollments: {
            type: Array,
        },
    },

    data: () => ({
        selectedRegistration: 'Semua',
    }),

    watch: {
        selectedRegistration() {
            this.updateFilteredEnrollments()
        },

        enrollments() {
            this.updateFilteredEnrollments()
        },
    },

    computed: {
        registrations() {
            if (!this.enrollments) {
                return []
            }

            const result = this.enrollments
                .reduce((result, enrollment) => {
                    const registrationLinkName =
                        enrollment.registrationLinkTitle
                            ? enrollment.registrationLinkTitle
                            : 'Umum'

                    if (!result.includes(registrationLinkName)) {
                        result.push(registrationLinkName)
                    }

                    return result
                }, [])
                .sort()
            result.unshift('Semua')

            return result
        },
    },

    methods: {
        updateFilteredEnrollments() {
            if (this.selectedRegistration == 'Semua') {
                this.$emit('update:filteredEnrollments', this.enrollments)
                return
            }

            const result = this.enrollments.filter((enrollment) => {
                if (this.selectedRegistration == 'Umum') {
                    return enrollment.registrationLinkTitle == null
                }

                return (
                    enrollment.registrationLinkTitle ==
                    this.selectedRegistration
                )
            })

            this.$emit('update:filteredEnrollments', result)
        },
    },

    created() {
        this.updateFilteredEnrollments()
    },
}
</script>
